import { render, staticRenderFns } from "./3_QualificationDetails.vue?vue&type=template&id=a945686a&"
import script from "./3_QualificationDetails.vue?vue&type=script&lang=js&"
export * from "./3_QualificationDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports